import React, { createContext, useContext, useState, useEffect } from 'react';
import { useCarrito } from './contextCarrito';
import { useFavoritos } from './contextFavoritos';
import { useProductos } from './contextProductos';
import { useLocation, useNavigate } from 'react-router-dom';
import { useVariables } from './contextVariables';
import { rubrosPerfiles } from './rubros';

const TiendaContext = createContext();

function useTienda() {
  return useContext(TiendaContext);
}

function TiendaProvider({ children }) {
  const [rubroActivo, setRubroActivo] = useState(null);
  const [marcaActiva, setMarcaActiva] = useState(null);
  const [srubroActivo, setSrubroActivo] = useState(null);
  const [coloresActivos, setColoresActivos] = useState([]);
  const [productoSeleccionado, setProductoSeleccionado] = useState(null);
  const [isTablet, setIsTablet] = useState(window.innerWidth <= 820);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [isFold, setIsFold] = useState(window.innerWidth <= 280);
  const [mostrarPagos, setMostrarPagos] = useState(false);
  const [ofertasSelected, setOfertasSelected] = useState(false);
  const [cortinasSelected, setCortinasSelected] = useState(false);
  const [eliminadosSelected, setEliminadosSelected] = useState(false);
  const [eliminadosDeProcesosSelected, setEliminadosDeProcesosSelected] = useState(false);
  const [softwareSelected, setSoftwareSelected] = useState(false);
  const [procesosSelected, setProcesosSelected] = useState(false);
  const [tipoProceso, setTipoProceso] = useState(null);
  const [stipoProceso, setStipoProceso] = useState(null);
  const [acabado, setAcabado] = useState(null);
  const [menuAbierto, setMenuAbierto] = useState(false);
  const [rubros, setRubros] = useState([]);
  const [imagenSoftwareSeleccionada, setImagenSoftwareSeleccionada] = useState(null);
  const [categoriaSeleccionadaPinturas, setCategoriaSeleccionadaPinturas] = useState(null);
  const [colorSeleccionado, setColorSeleccionado] = useState(null);

  const {
    setOrdenamientoActivo,
    procesos,
    setProcesos,
    marcas,
    ordenamientoActivo,
    ordenarProductos,
    productosIndexado
  } = useProductos();

  const {
    setCarritoAbierto,
  } = useCarrito();

  const {
    setFavoritosAbierto
  } = useFavoritos();

  const {
    backend
  } = useVariables();

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsTablet(window.innerWidth <= 820);
      setIsMobile(window.innerWidth <= 767);
      setIsFold(window.innerWidth <= 280);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    obtenerRubros();
  }, [])

  // Actualizar estados de los filtros basado en los parámetros de la URL
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const rubro = params.get('rubro');
    const marca = params.get('marca');
    const srubro = params.get('srubro');
    const colores = params.getAll('colores');
    const ordenamiento = params.getAll('ordenamiento');

    if (rubro) {
      if (rubro !== 'Procesos' && rubro !== 'Eliminados' && rubro !== 'Cortinas' && rubro !== 'Software' && rubro != 'Ofertas') {
        setRubroActivo(rubros.find(rubroObjeto => rubroObjeto.id === rubro));
      } else {
        if (rubro == 'Cortinas') {
          setCortinasSelected(true);
        } else if (rubro == 'Procesos') {
          setProcesosSelected(true);
        } else if (rubro == 'Software') {
          setSoftwareSelected(true);
        } else if (rubro == 'Eliminados') {
          setEliminadosSelected(true);
        } else if (rubro == 'EliminadosDeProcesos') {
          setEliminadosDeProcesosSelected(true);
        } else if (rubro == 'Ofertas') {
          setOfertasSelected(true);
        }
      }
    }

    const rubroEncontrado = rubros.find(rubroActual => rubroActual.id == rubro);

    if (marca) {
      setMarcaActiva(marcas.find(marcaPerfil => marcaPerfil.nombre == marca));
    }

    if (rubro && srubro) {
      if (marca) {
        const marcaEncontrada = marcas.find(marcaActual => marcaActual.nombre == marca);

        if (marcaEncontrada && marcaEncontrada.colores && marcaEncontrada.colores.length > 0) {
          const srubroEncontrado = marcaEncontrada.colores.find(busquedaColor => busquedaColor.nombre == srubro);

          setSrubroActivo(srubroEncontrado);

          setColoresActivos(srubroEncontrado.srubros.filter(s => colores.includes(s.nombre)));
        }
      }
      else {
        if (rubroEncontrado && rubroEncontrado.srubros.length > 0) {
          setSrubroActivo(rubroEncontrado.srubros.find(busquedaSrubro => busquedaSrubro.id == srubro));
        }

        setColoresActivos(colores);
      }
    }

    ordenamiento.length > 0 && setOrdenamientoActivo(ordenamiento);

  }, [marcas, rubros, setProcesos]);

  // Actualizar la URL cuando los filtros cambian
  useEffect(() => {
    if (marcas.length > 0 && rubros.length > 0) {
      const params = new URLSearchParams();

      if (rubroActivo) {
        params.set('rubro', rubroActivo.id);
      }
      else if (procesosSelected && Object.keys(procesos).length > 0) {
        params.set('rubro', 'Procesos');
      }
      if (cortinasSelected) {
        params.set('rubro', 'Cortinas')
      }
      else if (eliminadosSelected) {
        params.set('rubro', 'Eliminados')
      }
      else if (eliminadosDeProcesosSelected) {
        params.set('rubro', 'EliminadosDeProcesos')
      }
      else if (softwareSelected) {
        params.set('rubro', 'Software')
      }
      else if (ofertasSelected) {
        params.set('rubro', 'Ofertas')
      }

      if (marcaActiva) params.set('marca', marcaActiva.nombre);

      if (srubroActivo) {
        if (rubroActivo.id == 'Perfiles') {
          params.set('srubro', srubroActivo.nombre)
        }
        else {
          params.set('srubro', srubroActivo.id)
        }
      }

      if (ordenamientoActivo && ordenamientoActivo != 'destacados') params.set('ordenamiento', ordenamientoActivo)

      coloresActivos.forEach(color => params.append('colores', rubroActivo.id == 'Perfiles' ? (color.nombre) : (color)));
      navigate({ search: params.toString() });
    }
  }, [marcaActiva, rubroActivo, srubroActivo, coloresActivos, procesosSelected, cortinasSelected, eliminadosSelected, tipoProceso, stipoProceso, procesos, ordenamientoActivo, navigate]);

  const salirDeTienda = () => {
    togglearRubro(null);
    togglearSrubro(null);
    togglearMarca(null);
    togglearSrubro(null);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setColoresActivos([]);
    setCarritoAbierto(false);
    setFavoritosAbierto(false);
    setEliminadosDeProcesosSelected(false);
    setOrdenamientoActivo('destacados');
    setOfertasSelected(false);
  }

  const seleccionarEliminados = () => {
    setCortinasSelected(false);
    setProcesosSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setSoftwareSelected(false);
    setEliminadosDeProcesosSelected(false);
    setOfertasSelected(false);

    if (!eliminadosSelected) {
      setRubroActivo([]);
      setEliminadosSelected(true);
    }
    else {
      setEliminadosSelected(false);
      setRubroActivo(null);
    }
  }

  const seleccionarCortinas = () => {
    setEliminadosSelected(false);
    setProcesosSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setSoftwareSelected(false);
    setEliminadosDeProcesosSelected(false);
    setOfertasSelected(false);

    if (!cortinasSelected) {
      setRubroActivo([]);
      setCortinasSelected(true);
    }
    else {
      setCortinasSelected(false);
      setRubroActivo(null);
    }
  }

  const seleccionarProcesos = () => {
    setEliminadosSelected(false);
    setCortinasSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setSoftwareSelected(false);
    setEliminadosDeProcesosSelected(false);
    setOfertasSelected(false);

    if (!procesosSelected) {
      setRubroActivo(null);
      setCategoriaSeleccionadaPinturas(null);
      setSrubroActivo(null);
      setMarcaActiva(null);
      setProcesosSelected(true);
    }
    else {
      setProcesosSelected(false);
      setRubroActivo(null);
    }
  }

  const seleccionarSoftware = () => {
    setEliminadosSelected(false);
    setCortinasSelected(false);
    setProcesosSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setEliminadosDeProcesosSelected(false);
    setOfertasSelected(false);

    if (!softwareSelected) {
      setRubroActivo([]);
      setSoftwareSelected(true);
    }
    else {
      setRubroActivo(null);
      setSoftwareSelected(false);
    }
  }

  const seleccionarEliminadosDeProcesos = () => {
    setEliminadosSelected(false);
    setCortinasSelected(false);
    setProcesosSelected(false);
    setSoftwareSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setOfertasSelected(false);

    if (!eliminadosDeProcesosSelected) {
      setRubroActivo([]);
      setEliminadosDeProcesosSelected(true);
    }
    else {
      setRubroActivo(null);
      setEliminadosDeProcesosSelected(false);
    }
  }

  const seleccionarOfertas = () => {
    setEliminadosSelected(false);
    setCortinasSelected(false);
    setProcesosSelected(false);
    setSoftwareSelected(false);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setEliminadosDeProcesosSelected(false);

    if (!ofertasSelected) {
      setRubroActivo([]);
      setOfertasSelected(true);
    }
    else {
      setRubroActivo(null);
      setOfertasSelected(false);
    }
  }

  const togglearRubro = (rubro) => {
    setCortinasSelected(false);
    setEliminadosSelected(false);
    setProcesosSelected(false);
    setSrubroActivo(null);
    setMarcaActiva(null);
    setTipoProceso(null);
    setStipoProceso(null);
    setAcabado(null);
    setSoftwareSelected(false);
    setEliminadosDeProcesosSelected(false);
    setOfertasSelected(false);

    if (rubroActivo == rubro) {
      setRubroActivo(null);
    }
    else {
      setRubroActivo(rubro);
    }
  }

  const togglearMarca = (marca) => {
    if (marcaActiva == marca) {
      setMarcaActiva(null);
    }
    else {
      setMarcaActiva(marca);
    }
    setSrubroActivo(null);
  }

  const togglearSrubro = (srubro) => {
    if (srubroActivo == srubro) {
      setSrubroActivo(null)
    }
    else {
      setSrubroActivo(srubro)
    }
  }

  const obtenerRubros = async () => {
    const response = await fetch(`${backend}/rubros/get`);

    if (response.ok) {
      const rubros = await response.json();
      setRubros(rubros);
    }
  }

  return (
    <TiendaContext.Provider value={{
      seleccionarCortinas,
      cortinasSelected,
      setCortinasSelected,
      mostrarPagos,
      setMostrarPagos,
      isTablet,
      isFold,
      isMobile,
      productoSeleccionado,
      setProductoSeleccionado,
      rubroActivo,
      setRubroActivo,
      coloresActivos,
      setColoresActivos,
      eliminadosSelected,
      setEliminadosSelected,
      seleccionarEliminados,
      togglearRubro,
      srubroActivo,
      togglearSrubro,
      salirDeTienda,
      marcaActiva,
      togglearMarca,
      procesosSelected,
      seleccionarProcesos,
      setTipoProceso,
      tipoProceso,
      stipoProceso,
      setStipoProceso,
      acabado,
      setAcabado,
      menuAbierto,
      setMenuAbierto,
      obtenerRubros,
      marcas,
      rubros,
      softwareSelected,
      seleccionarSoftware,
      imagenSoftwareSeleccionada,
      setImagenSoftwareSeleccionada,
      seleccionarEliminadosDeProcesos,
      eliminadosDeProcesosSelected,
      ofertasSelected,
      setOfertasSelected,
      seleccionarOfertas,
      categoriaSeleccionadaPinturas,
      setCategoriaSeleccionadaPinturas,
      colorSeleccionado,
      setColorSeleccionado
    }}>
      {children}
    </TiendaContext.Provider>
  );
}

export { TiendaContext, useTienda, TiendaProvider };
